import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexDropdown',
  setup(__props) {

const BasicDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/BasicDropdown.vue"))
const RoundedDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/RoundedDropdown.vue"))
const SplitDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/SplitDropdown.vue"))
const DropdownSection = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/DropdownSection.vue"))
const UniqueDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/UniqueDropdown.vue"))
const JustifyContents = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/JustifyContents.vue"))
const AlignmentsDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/AlignmentsDropdown.vue"))
const HelperCard = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/HelperCard.vue"))
const DividerDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/DividerDropdown.vue"))
const DropdownSizing = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/DropdownSizing.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Dropdown",
      title: "Dropdown"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BasicDropdown)),
        _createVNode(_unref(RoundedDropdown)),
        _createVNode(_unref(SplitDropdown)),
        _createVNode(_unref(DropdownSection)),
        _createVNode(_unref(UniqueDropdown)),
        _createVNode(_unref(JustifyContents)),
        _createVNode(_unref(AlignmentsDropdown)),
        _createVNode(_unref(HelperCard)),
        _createVNode(_unref(DividerDropdown)),
        _createVNode(_unref(DropdownSizing))
      ])
    ])
  ], 64))
}
}

})